import { useEffect } from "react";

const SITE = "https://wantedtcg.it";

// Titolo, description, canonical e OG unici per pagina (SPA: l'HTML di base è condiviso)
export function useSeo({ title, description, path, robots }) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", description);
    if (robots) setMeta("name", "robots", robots);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    if (path) {
      setMeta("property", "og:url", `${SITE}${path}`);
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
      }
      link.href = `${SITE}${path}`;
    }
  }, [title, description, path, robots]);
}
